import React, { useEffect, useId, useRef } from "react";

let activeDropdown = null;

const BaseDropdown = ({
  children,
  open,
  setOpen,
  className,
  style,
  closeOnOutsideClick = true,
  ...props
}) => {
  const dropdownRef = useRef(null);
  const id = useId();

  useEffect(() => {
    if (open) {
      if (activeDropdown && activeDropdown !== id) {
        activeDropdown(false);
      }

      activeDropdown = setOpen;
    }

    return () => {
      if (activeDropdown === setOpen) {
        activeDropdown = null;
      }
    };
  }, [open, id, setOpen]);

  useEffect(() => {
    if (!closeOnOutsideClick) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [closeOnOutsideClick, setOpen]);

  if (!open) return null;

  return (
    <div
      ref={dropdownRef}
      onClick={(e) => e.stopPropagation()}
      {...props}
      style={style}
      className={`${className}  absolute top-4 left-[0px] bg-white  rounded-lg shadow-lg py-1 px-2 transition-all z-10 duration-300 ease-in-out transform ${
        open ? "opacity-100 scale-100" : "opacity-0 scale-95"
      }`}
    >
      {children}
    </div>
  );
};

export default BaseDropdown;
